import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=4975802e&scoped=true&"
import script from "./WhatsNew.vue?vue&type=script&lang=ts&"
export * from "./WhatsNew.vue?vue&type=script&lang=ts&"
import style0 from "./WhatsNew.vue?vue&type=style&index=0&id=4975802e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4975802e",
  null
  
)

export default component.exports